module.exports = __webpack_public_path__ + "static/img/bn02.6481f688.png";